import moment from 'moment';

export const formattedDate = function (date, format = "") {
    if (date == null || date == undefined || date == "")
        return "";
    let momentInstance = moment(date).locale("tr").format(format == "" ? "DD MMMM YYYY" : format);

    return momentInstance;

}

export const formattedDateTime = function (date, format = "") {
    format;
    if (date == null || date == undefined || date == "")
        return "";
    let momentInstance = moment(date).locale("tr").format("DD MMMM YYYY HH:mm:ss");

    return momentInstance;

};

export const formatTest = (date, format = "") => {
    if (date == null || date == undefined || date == "")
        return "";
    let momentInstance = moment(date).locale("us").format(format == "" ? "YYYY/MM/DD" : format);

    return momentInstance;
};

export const formatInput = (data = "") => {
    if (data == null || data == undefined || data == "")
        return "";
    return  data.split(',');
};